import * as msal from '@azure/msal-browser';
import { EventType } from '@azure/msal-browser'; // ESM
import Vue from 'vue';
import router from './router/routing';



var msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID,
    authority: process.env.VUE_APP_AZURE_AD_AUTHORITY, 
    redirectUri: process.env.VUE_APP_AZURE_AD_REDIRECT_URL, 
  
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case msal.LogLevel.Error:
            // console.error(message);
            return;
          case msal.LogLevel.Info:
            // console.info(message);
            return;
          case msal.LogLevel.Verbose:
            // console.debug(message);
            return;
          case msal.LogLevel.Warning:
            // console.warn(message);
            return;
        }
      }
    }
  }
};

let scopes = ['openid', 'profile', 'Sites.ReadWrite.All', 'Files.ReadWrite.All'];

let graphRequest = {
  scopes: scopes
};

const requestScopes = [process.env.VUE_APP_AZURE_API_SCOPE];

class User {
  msalInstance = new msal.PublicClientApplication(msalConfig);
  interactionInProgress = false; // Track interaction status

  static async createAsync() {
    let instanceObj = new User();
    await instanceObj.msalInstance.initialize();

    // Listen to MSAL events to track interaction progress
    instanceObj.msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_START || event.eventType === EventType.ACQUIRE_TOKEN_START) {
        instanceObj.interactionInProgress = true;
      } else if (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.LOGIN_FAILURE ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        instanceObj.interactionInProgress = false;
      }
    });

    // Handle the redirect promise when the page loads to resolve ongoing interactions
    instanceObj.msalInstance.handleRedirectPromise()
      .then(response => {
        if (response !== null) {
          instanceObj.handleResponse(response, instanceObj);
        }
      })
      .catch(error => {
        console.error('Error handling redirect response:', error);
      });

    return instanceObj;
  }

  selectAccount(instanceObj) {
    instanceObj.getAccount();
  }

  getAccount() {
    let currentAccounts = this.msalInstance.getAllAccounts();

    if (!currentAccounts) {
      return null;
    } else if (currentAccounts.length > 1) {
      // For now return first account
      return currentAccounts[0];
    } else if (currentAccounts.length === 1) {
      return currentAccounts[0];
    }
  }

  loginSuccess() {
    router.go(0);
  }

  handleResponse(response, instanceObj) {
    /**
     * To see the full list of response object properties, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#response
     */

    let account = null;
    if (response !== null) {
      account = response.account;
    } else {
      account = instanceObj.getAccount();
    }

    if (account !== null) {
      instanceObj.msalInstance.setActiveAccount(account); // Set the active account properly
      instanceObj.loginSuccess();
    }
  }

  async signIn() {
    if (this.interactionInProgress || this.isAuthenticated) {
      console.log('Already authenticated or interaction in progress.');
      return;
    }

    await this.msalInstance.loginRedirect(graphRequest);
  }

  signOut() {
    Vue.cookie.delete('companyId');
    Vue.cookie.delete('selectedCustomers');

    this.msalInstance.logoutRedirect({
      postLogoutRedirectUri: ""
    });
  }

  // Obsolute
  get displayName() {
    let account = this.getAccount();

    return account.username;
  }

  get isAuthenticated() {
    return this.getAccount();
  }

  get userName() {
    const account = this.getAccount();
    if (account) {
      return account.username;
    } 

    return '';
  }

  // Not being used, can be deleted?
  get isAdmin() {
    return true;
  }

  async getApiAccessToken() {
    const account = this.getAccount();

    if (!account) {
      // If no account is found, try to get all accounts and use the first one
      const allAccounts = this.msalInstance.getAllAccounts();
      if (allAccounts && allAccounts.length > 0) {
        const firstAccount = allAccounts[0];
        this.msalInstance.setActiveAccount(firstAccount);
      } else {
        // No accounts available, redirect to login
        await this.signIn();
        return null;
      }
    }

    const currentAccount = this.getAccount();
    if (!currentAccount) {
      throw new Error('No authenticated account found');
    }

    const accessTokenRequest = {
      account: currentAccount,
      scopes: requestScopes  // Use .default to get a token for your API
    };

    try {
      const accessTokenResponse = await this.msalInstance.acquireTokenSilent(accessTokenRequest);
      return accessTokenResponse.accessToken;
    } catch (error) {
      console.error('Error acquiring API token:', error);
      
      // If silent token acquisition fails, try interactive login
      if (error.errorCode === 'consent_required' || error.errorCode === 'interaction_required') {
        try {
            await this.msalInstance.acquireTokenRedirect(accessTokenRequest);
            return null;
        } catch (interactiveError) {
          console.error('Interactive token acquisition failed:', interactiveError);
          throw interactiveError;
        }
      }
      
      throw error;
    }
  }

  async getGraphToken() {
    const graphTokenRequest = {
      scopes: scopes,
      account: this.getAccount()  // Ensure you're using the current user account
    };

    return await this.msalInstance.acquireTokenSilent(graphTokenRequest)
      .then(function (graphTokenResponse) {
        let graphAccessToken = graphTokenResponse.accessToken;

        return graphAccessToken;
      })
      .catch(function (error) {
        console.error('Error acquiring Graph API token:', error);
      });
  }
}

const myUser = await User.createAsync();


export let user = myUser;
